import * as React from "react";
import { ThemeIcon, Text, Button, Stack, Center } from "@mantine/core";
import { Search } from "lucide-react";

interface NotFoundStateProps {
    title?: string;
    message?: string;
    icon?: React.ReactNode;
    actionLabel?: string;
    onAction?: () => void;
    showAction?: boolean;
}

export const NotFoundState: React.FC<NotFoundStateProps> = ({
    title = "Resource Not Found",
    message = "The resource you are looking for does not exist or you don't have permission to view it.",
    icon = <Search size={32} />,
    actionLabel = "Back to Safety",
    onAction,
    showAction = true,
}) => {
    return (
        <Center py={60}>
            <Stack align="center" gap="xs" style={{ textAlign: 'center', maxWidth: 400 }}>
                <ThemeIcon size={60} radius="xl" color="gray" variant="light" mb="md">
                    {icon}
                </ThemeIcon>
                <Text size="xl" fw={600}>
                    {title}
                </Text>
                <Text c="dimmed" size="sm">
                    {message}
                </Text>
                {showAction && onAction && (
                    <Button mt="lg" onClick={onAction} variant="light">
                        {actionLabel}
                    </Button>
                )}
            </Stack>
        </Center>
    );
};
